import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MarketView } from '@api-proxies';
import { MarketService } from '@http/clients/market.service';
import { EditorComponentBase, GenericDropdownComponent } from 'ngx-lib';

@Component({
    selector: 'app-market-editor',
    templateUrl: './market-editor.component.html',
    styleUrls: ['./market-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownComponent]
})
export class MarketEditorComponent extends EditorComponentBase<number | null> implements OnInit {
    markets: MarketView[];
    selectedMarket?: MarketView;

    constructor(private marketService: MarketService) {
        super();
        this.markets = [];
    }

    async ngOnInit(): Promise<void> {
        this.markets = await this.marketService.getAll();
        this.selectedMarket = this.markets?.find((x) => x.id === this.bindingProperty);
    }

    onSelectMarket() {
        this.bindingProperty = this.selectedMarket?.id ?? null;
        this.valueChange.emit();
    }
}
